import { render, staticRenderFns } from "./image-text-detail.vue?vue&type=template&id=35feb2d3&scoped=true&"
import script from "./image-text-detail.vue?vue&type=script&lang=js&"
export * from "./image-text-detail.vue?vue&type=script&lang=js&"
import style0 from "./image-text-detail.vue?vue&type=style&index=0&id=35feb2d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35feb2d3",
  null
  
)

export default component.exports